import { Component, Injector, OnInit } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver/FileSaver';
import { of } from 'rxjs';
import { ECONOMIC_STUDY_NAME, LAYOUT_URL } from '../../../../shared/utils/constants';
import { ModalComponent } from '../../../../vass-core/components/modal/modal.component';
import { BeginReviewService } from '../../../services/begin-review/begin-review.service';

import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';

@Component({
  selector: 'app-begin-review',
  templateUrl: './begin-review.component.html',
  styleUrls: ['./begin-review.component.scss'],
  standalone: false,
})
export class BeginReviewComponent implements OnInit {
  private modalComponent: any;

  public formChecks: UntypedFormGroup;
  public pfdDownloaded: boolean = !!sessionStorage.getItem('pfdDownloaded');
  public msgPDFDownloaded: string = '';
  public ECONOMIC_STUDY_NAME = ECONOMIC_STUDY_NAME;
  public downloading = false;

  public isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  public isdownloadByUrl = false;
  public urlFipre: SafeUrl;

  private deviceInfo: DeviceInfo;

  constructor(
    private _inj: Injector,
    private _beginReviewService: BeginReviewService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private sanitizer: DomSanitizer,
    private deviceService: DeviceDetectorService,
  ) {
    this.modalComponent = this._inj.get(ModalComponent);
  }

  ngOnInit(): void {
    this.initForm();
    this.deviceInfo = this.deviceService.getDeviceInfo();
    if (this.isSafari && parseFloat(this.deviceInfo.browser_version) < 13) {
      this.getUrlPDF();
      this.isdownloadByUrl = true;
    }
  }

  initForm() {
    this.formChecks = this.fb.group({
      fipre: [false, Validators.required, this.isChecked.bind(this)],
      cirbe: [false, Validators.required, this.isChecked.bind(this)],
    });
  }

  isChecked(control: AbstractControl) {
    let respuesta;
    if (!control.value) {
      respuesta = { isTrue: control.value };
    }
    return of(respuesta);
  }

  public accept() {
    // hacer peticion al servidor para actualizar el estado
    if (this.formChecks.valid && this.pfdDownloaded) {
      const body = {
        cirbe: this.formChecks.controls.cirbe.value,
      };
      this._beginReviewService.beginRewiew(body).subscribe(
        (resp) => {
          this.modalComponent.accept();
          this.router.navigate([LAYOUT_URL]);
          sessionStorage.removeItem('pfdDownloaded');
        },
        (err) => {},
      );
    } else {
      for (const campo in this.formChecks.controls) {
        this.formChecks.controls[campo].markAsTouched();
      }
      this.pfdDownloaded
        ? (this.msgPDFDownloaded = '')
        : (this.msgPDFDownloaded = 'begin_review_must_download_document');
    }
  }

  public cancel() {
    this.modalComponent.reject();
  }

  getUrlPDF() {
    this._beginReviewService.getPDFfipre().subscribe(
      (blob) => {
        this.urlFipre = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
      },
      (err) => {},
    );
  }

  setDownloaded(donwload) {
    this.pfdDownloaded = true;
    this.msgPDFDownloaded = '';
    sessionStorage.setItem('pfdDownloaded', 'true');
    donwload.donwload = 'fipre.pdf';
    donwload.href = this.urlFipre['changingThisBreaksApplicationSecurity'];
  }

  downloadFIPRE() {
    this.downloading = true;
    this._beginReviewService.getPDFfipre().subscribe(
      (blob) => {
        this.downloading = false;
        this.pfdDownloaded = true;
        this.msgPDFDownloaded = '';
        sessionStorage.setItem('pfdDownloaded', 'true');
        saveAs(blob, 'fipre');
      },
      (err) => {},
    );
  }

  openToast(id: string) {
    const elementHTML = document.getElementById(id);
    elementHTML.focus();
  }
}
